import DateTimePicker from '../../components/controls/DateTimePicker/DateTimePicker';
import classes from './generate-deposit-summary-report-form.module.css';

export interface GenerateDepositSummaryReportFormProps { }

function GenerateDepositSummaryReportForm(props: GenerateDepositSummaryReportFormProps) {

	return (
		<div className='row'>
			<div className="col">
				<h3>View Deposit Listing</h3>
				<div className="row">
					<div className="col">
						<DateTimePicker id='startDate' text='Start Date' type='date' />
					</div>
					<div className="col">
						<DateTimePicker id='endDate' text='End Date' type='date' />
					</div>
					<div className="col">
						<label htmlFor="" className='control-label' style={{ visibility: "hidden" }}>View</label>
						<button className='btn btn-secondary'>Preview...</button>
					</div>
				</div>
			</div>
		</div>
	);
}

export default GenerateDepositSummaryReportForm;